<template>
  <div class="minimized-files-container" :style="{ bottom: tasksManagerItems?.length ? '60px' : '20px' }">
    <!-- Botones con v-menu individual -->
    <div
      v-for="type in fileTypes"
      :key="type.key"
      class="file-type-button"
    >
      <v-menu
        v-model="openMenus[type.key]"
        :close-on-content-click="false"
        offset-x
				nudge-left="30"
        left
        max-width="320"
        min-width="320"
        max-height="400"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-badge
            :content="type.files.length"
            :value="type.files.length > 0"
            overlap
            color="#5E85EF"
          >
            <v-btn 
              fab 
              small 
              class="file-btn"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>{{ type.icon }}</v-icon>
            </v-btn>
          </v-badge>
        </template>

        <v-card class="files-panel">
          <v-card-title class="panel-header">
            <span>
              {{ type.label }} ({{ type.files.length }})
            </span>

            <v-btn icon x-small color="white" @click="closeMenu(type.key)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-2">
            <div 
              v-for="(file) in type.files"
              :key="file.id"
              class="file-item"
              @click="openFile(file, type)"
            >
              <div class="file-left">
                <v-icon size="18">{{ type.icon }}</v-icon>

                <div class="file-info">
                  <p class="file-name text-truncate">
                    {{ file.name }}
                  </p>
                  <p class="file-size">
                    {{ getFileSize(file.size) }}
                  </p>
                </div>
              </div>

              <v-btn icon x-small @click.stop="closeFile(file, type)">
                <v-icon size="16">mdi-close-circle</v-icon>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-menu>
    </div>

		<!-- Solo mostrar un archivo abierto a la vez -->
		<v-dialog
			v-model="hasOpenFile"
			fullscreen
			transition="dialog-bottom-transition"
		>
			<StandaloneMediaViewer 
				v-if="activeFile && activeFile.pathmedia"
				:itemProp="activeFile"
				:fromInternalView="true"
				@open-morphable="openItemMorphable"
				@close="closeActiveFile"
			/>
			<StandaloneDocumentViewer
				v-if="activeFile && activeFile.pathdoc"
				:itemProp="activeFile"
				:fromInternalView="true"
				@open-morphable="openItemMorphable"
				@close="closeActiveFile"
			/>
			<StandaloneForgeViewer
				v-if="activeFile && activeFile.forge_file"
				:itemProp="activeFile"
				:fromInternalView="true"
				@open-morphable="openItemMorphable"
				@close="closeActiveFile"
			/>
		</v-dialog>
  </div>
</template>

<script>
import StandaloneMediaViewer from '@/components/Globals/Helpers/StandaloneMediaViewer'
import StandaloneDocumentViewer from '@/components/Globals/Helpers/StandaloneDocumentViewer'
import StandaloneForgeViewer from '@/components/Globals/Helpers/StandaloneForgeViewer'
import { getParentElement } from '@/helpers/api/general'

export default {
  name: 'MinimizedFileManager',
	components: { StandaloneMediaViewer, StandaloneDocumentViewer, StandaloneForgeViewer },
  data: () => ({
    openMenus: {},
    activeFile: null
  }),

  computed: {
		tasksManagerItems() {
			return this.$store.globalStore.state.openTasksHandler
		},
    openFiles() {
      return this.$store.globalStore.state.openFilesHandler || []
    },

    hasOpenFile() {
      return this.activeFile !== null
    },

    fileTypes() {
      return [
        {
          key: 'images',
          label: 'Imágenes',
          icon: 'mdi-image-multiple',
          files: this.openFiles.filter(f => f.pathmedia)
        },
        {
          key: 'documents',
          label: 'Documentos',
          icon: 'mdi-file-document',
          files: this.openFiles.filter(f => f.pathdoc && !f.pathmedia)
        },
        {
          key: 'forge',
          label: 'Autodesk',
          icon: 'mdi-file-cad-box',
          files: this.openFiles.filter(
            f => f.forge_file && !f.pathmedia && !f.pathdoc
          )
        }
      ].filter(type => type.files.length > 0)
    }
  },

  methods: {
    closeMenu(key) {
      this.$set(this.openMenus, key, false)
    },

    getFileSize(bytes) {
      if (!bytes) return '0 B'

      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return (
        Math.round((bytes / Math.pow(k, i)) * 100) / 100 +
        ' ' +
        sizes[i]
      )
    },

    closeFile(file, type) {
      const globalIndex = this.openFiles.findIndex(
        f => f.id === file.id
      )

      if (globalIndex !== -1) {
        this.$store.globalStore.commit(
          'removeFileFromFileManagerHandler',
          globalIndex
        )
      }

      // Cerrar el menú si ya no hay archivos
      if (type.files.length === 1) {
        this.closeMenu(type.key)
      }
    },

    openFile(file, type) {
      // Establecer el archivo como abierto
      this.activeFile = {...file}
			this.closeFile(file, type)
      this.closeMenu(type.key)
    },

    closeActiveFile() {
      this.activeFile = null
    },

		async openItemMorphable(item){
			const typeMap = {
				'App\\Models\\TasksRestrictions': 'task',
				'App\\Models\\TasksRestrictionsInteractions': 'task_interaction',
				'App\\Models\\Rdi': 'rdi',
				'App\\Models\\RdiInteractions': 'rdi_interaction',
				'App\\Models\\Additional': 'additional',
				'App\\Models\\AdditionalRevision': 'additional_revision',
				'App\\Models\\AdditionalObservation': 'additional_observation'
			}
			const parentTypesMap = {
				'App\\Models\\TasksRestrictions': 'task',
				'App\\Models\\TasksRestrictionsInteractions': 'task',
				'App\\Models\\Rdi': 'rdi',
				'App\\Models\\RdiInteractions': 'rdi',
				'App\\Models\\Additional': 'additional',
				'App\\Models\\AdditionalRevision': 'additional',
				'App\\Models\\AdditionalObservation': 'additional'
			}
			if(!typeMap[item.morphable_type]){
				return
			}
			const data = {
				item_id: item.morphable_id,
				item_type: typeMap[item.morphable_type]
			}
			if(parentTypesMap[item.morphable_type] == 'task'){
				this.$store.consultasStore.commit('setCurrentTarea', { loading: true })
			}
			else if(parentTypesMap[item.morphable_type] == 'rdi'){
				this.$store.rdiStore.commit('setCurrentRDI', { loading: true })
			}
			else if(parentTypesMap[item.morphable_type] == 'additional'){
				this.$store.adicionalesStore.commit('setCurrentAdicional', { loading: true })
			}

			const element = await getParentElement(data)
			if(element.code == 200){
				if(parentTypesMap[item.morphable_type] == 'task'){
					this.$store.consultasStore.commit('setCurrentTarea', element.task)
				}
				else if(parentTypesMap[item.morphable_type] == 'rdi'){
					this.$store.rdiStore.commit('setCurrentRDI', element.rdi)
				}
				else if(parentTypesMap[item.morphable_type] == 'additional'){
					this.$store.adicionalesStore.commit('setCurrentAdicional', element.additional)
				}
			}
		},
  }
}
</script>

<style scoped>
.minimized-files-container {
  position: fixed;
  right: 20px;
  bottom: 20px;

  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  gap: 10px;

  z-index: 100;
}

/* Botones */
.file-type-button {
  transition: all 0.25s ease;
}

.file-btn {
  background: linear-gradient(135deg, #2D4B95, #5E85EF);
  color: white;
  box-shadow: 0 4px 12px rgba(45, 75, 149, 0.4);
  transition: all 0.25s ease;
}

.file-btn:hover {
  transform: translateY(-2px) scale(1.05);
}

/* Panel lateral */
.files-panel {
  width: 320px;
  min-width: 320px;
  max-width: 320px;

  max-height: 400px;
  overflow-y: auto;

  border-radius: 12px;
  background: white;
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

/* Header */
.panel-header {
  background: #2D4B95;
  color: white;
  font-size: 14px;
  padding: 8px 12px;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Items */
.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 8px;
  border-radius: 8px;
  background: #f5f7fa;
  margin-bottom: 6px;

  cursor: pointer;
  transition: all 0.2s ease;
}

.file-item:hover {
  background: #e8ecf5;
  transform: translateX(2px);
}

.file-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.file-info {
  min-width: 0;
}

.file-name {
  font-size: 12px;
  font-weight: 600;
  margin: 0;
}

.file-size {
  font-size: 10px;
  color: #888;
  margin: 0;
}
</style>